export class CodigoPromocionAdd {

  
    codigo: string;
    etiquetaModificacionPrecio:string;
    porcentajeDescuento: number;
    fechaDesde: string;
    fechaHasta: string;
    proveedorId: number;
    categoriaId:number;
    productoId:number;
    pais:String;
    
  }


// WEBPACK FOOTER //
// ./src/app/pedido/codigos-promocion/codigo-descuento-add.model.ts